import { createMiddleware } from '../../shared/redux';
import {
    requestIntegration,
    requestIntegrationPlatformInfo,
    RETRIEVE_INTEGRATION_PLATFORM_INFO_IF_NEEDED,
    INTEGRATE_PLATFORM_IF_NEEDED,
} from './integrations-properties.state';
import { isPlatformIntegration } from '../auth';


export const integrationsPropertiesMiddleware = createMiddleware({
    [RETRIEVE_INTEGRATION_PLATFORM_INFO_IF_NEEDED]: (state) => {
        if (!isPlatformIntegration(state)) {
            return [];
        }
        return [requestIntegrationPlatformInfo()];
    },
    [INTEGRATE_PLATFORM_IF_NEEDED]: (state) => {
        if (!isPlatformIntegration(state)) {
            return [];
        }
        return requestIntegration();
    },
});
